//src/components/Cart.js

import React, { useContext } from "react";
import { itemContext } from "../context/ItemContext";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const { cart, clearCart, totalPrice } = useContext(itemContext);
  const navigate = useNavigate();

  return (
    <div className="cart">
      <h2>Your Cart</h2>
      <ul>
        {cart.map((product) => (
          <li key={product._id} className="cart-item">
            <img
              src={product.image}
              alt={product.name}
              className="cart-item-image"
              //style={{ width: "50px" }}
            />
            <div className="cart-item-details">
              <h3>{product.name}</h3>
              <p>Price: ${product.price?.toFixed(2)} </p>
              {/*<button onClick={() => removeFromCart(product)}>Remove</button> */}
            </div>
          </li>
        ))}
      </ul>
      <h3>Total Price: ${totalPrice.toFixed(2)} </h3>
      <button onClick={clearCart}>Clear Cart</button>
      <button onClick={() => navigate("/checkout")}>Proceed to checkout</button>
    </div>
  );
};

export default Cart;
